import { appConfig } from "../../config";
import { refreshAuthLogic } from "../fetchTools";
import axios from "axios";


export const verifyOtp = async (payload) => {
    try {
        const {status,data} = await axios.post(`${appConfig.BASE_API}/verifyotp`, payload)
        // const res = await fetch(`${appConfig.BASE_API}/verifyotp`, {
        //     method: 'POST',
        //     headers: {
        //         "Content-Type":"application/json",
        //         "Accept":"application/json"
        //     },
        //     mode: "cors",
        //     body: JSON.stringify(payload)
        // })
        // var data = null
        // try {
        //     var data = await res.text()
        // } catch (error) {
        //     data = null
        // }
        // return{status: res.status, data: data}
        return{status,data}
    } catch (error) {
        return { status: error.code, message: error.message }
    }
}

export const reSendOtp = async (payload) => {
    try {
        const {status,data} = await axios.post(`${appConfig.BASE_API}/resendotp`, payload)

        return{status,data}
    } catch (error) {
        return { status: error.code, message: error.message }
    }
}